<script>
  import Donut from './UC-donut.svelte';
  export let isLoading = false;
  export let val = '1';
  export let title = 'Data Card Title';
  export let titleLink = undefined;
  export let blurb = '';
  export let disabled = false;
  let ariaBlurb = title + ' health score is ' + val + '.';
</script>

  <div class="data-card layout-horizontal" aria-live="polite" aria-busy="{ isLoading }">
    <div class="container">
      {#if titleLink !== undefined}
      <a href="{titleLink}" aria-disabled="{disabled}" class="{disabled ? 'disabled' : ''}">
        <div class="card-header">
          {title}
        </div>
        <div class="row content">
          <div class="col copy">
            <p>{blurb}</p>
          </div>
          <div class="col-md-5 col-sm-12 value">
            <Donut val="{val}" ariaLabel="{ ariaBlurb }" />
          </div>
        </div>
      </a>
      {:else}
      <div class="card-header">
        {title}
      </div>
      <div class="row content">
        <div class="col-md-5 col-sm-12 copy">
          <p>{blurb}</p>
        </div>
        <div class="col">
          <Donut val="{val}" ariaLabel="{ ariaBlurb }" />
        </div>
      </div>
      {/if}
    </div>
  </div>

<style type="text/scss">
  .data-card {
    margin: 0 auto 3rem;
    border-radius: 1rem;
    overflow: hidden;
    transition: all ease-in-out 0.5s;
    filter: drop-shadow(0.2em 0.2em 0.2em rgba(0, 0, 0, 0.15));;
    background-color: #fff;
    /*min-height:38.5rem;*/

  }

  .data-card > .container {
    margin: 0;
    padding: 0rem;
    max-width: 100%;
  }

  .data-card > .container > a > .row, .data-card .content {
    margin: 0 ;
  }

  .data-card .card-header {
    width: 100%;
    color: #FFF;
    background-color: #e00122;
    padding: 0.5rem 1.5rem;
    margin: 0;
    font-weight: 700;
    text-transform: uppercase;
  }

  .data-card .copy p {
    font-size: 2rem;
    color: #000 !important;
    }

  .data-card .value {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  a.disabled > div {
    filter: grayscale(1);
  }
</style>
